import "./buttons.scss";

import { ReactComponent as PlusIcon } from "../icons/plusIcon.svg";

export const PlusButton = (props: {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  hint?: string;
}): JSX.Element => {
  return (
    <button className="plus rg-button rg-red" onClick={props.onClick} title={props.hint}>
      <PlusIcon />
    </button>
  );
};
